// Enterprise Scenario Constants
export const NUM_OF_RETRIES = 3;
export const RETRY_DELAY = 1500;
export const MAX_NUM_OF_GET_ACCESS_TOKEN_REQUESTS = 6;
export const DELAY_FOR_GET_ACCESS_TOKEN_REQUESTS = 0; /* Task Delay */
export const TIMEOUT_FOR_TOKEN_REQUEST_PROMISE: number = 60 * 1000;
export const TOKEN_FETCH_API = "TokenFetchApi";

// Consumer Scenario Constants
export const SCENARIO_NAME = "OWA_GetDelegationAccessToken";
export const AUTHORIZATION_URI = "https://login.live.com/oauth20_authorize.srf";
export const RETURN_URL_PATH = "/owa/auth/dt.aspx";
export const CLIENT_ID = "292841";

// Token request priority levels (lower = higher priority in PriorityTaskQueue)
export const TOKEN_PRIORITY_EXO = 0;
export const TOKEN_PRIORITY_NOTIFICATION = 5;
export const TOKEN_PRIORITY_DEFAULT = 10;

// Local Storage Constants for Latency Calculations
export const LATENCY_LOCAL_STORAGE_KEY = "auth-latency";
